import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_RESET_ENCRYPTION_SETTING_BEGIN,
  APP_SETTING_RESET_ENCRYPTION_SETTING_SUCCESS,
  APP_SETTING_RESET_ENCRYPTION_SETTING_FAILURE,
  APP_SETTING_RESET_ENCRYPTION_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function resetEncryptionSetting(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_RESET_ENCRYPTION_SETTING_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/encryption/reset`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            if (res.data.success === true) {
              dispatch({
                type: APP_SETTING_RESET_ENCRYPTION_SETTING_SUCCESS,
                data: res.data,
              });
              toast.success('Updated Successfully !', {});
            } else {
              dispatch({
                type: APP_SETTING_RESET_ENCRYPTION_SETTING_FAILURE,
                data: { error: err },
              });
              toast.error(`Failed: ${res.data.message}`, {});
            }
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_RESET_ENCRYPTION_SETTING_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_RESET_ENCRYPTION_SETTING_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissResetEncryptionSettingError() {
  return {
    type: APP_SETTING_RESET_ENCRYPTION_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_RESET_ENCRYPTION_SETTING_BEGIN:
      return {
        ...state,
        resetEncryptionSettingPending: true,
        resetEncryptionSettingError: null,
      };

    case APP_SETTING_RESET_ENCRYPTION_SETTING_SUCCESS:
      return {
        ...state,
        resetEncryptionSettingPending: false,
        resetEncryptionSettingError: null,
        projectDetail: {
          ...state.projectDetail,
          encryptions: action.data.encryptions,
        },
      };

    case APP_SETTING_RESET_ENCRYPTION_SETTING_FAILURE:
      return {
        ...state,
        resetEncryptionSettingPending: false,
        resetEncryptionSettingError: action.data.error,
      };

    case APP_SETTING_RESET_ENCRYPTION_SETTING_DISMISS_ERROR:
      return {
        ...state,
        resetEncryptionSettingError: null,
      };

    default:
      return state;
  }
}
